import { useContext, useEffect, useState } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const SetupTraining = ({ end }) => {
	const {personalization_state} = useContext(ToolContext)
	const {walkthrough, startHere} = personalization_state
	const [firstStepReady, setFirstStepReady] = useState(false);

	const endTour = ()=>{
		walkthrough.set((p) => ({ ...p, setupTraining: false}))
		startHere.set((p) => ({ ...p, show: true}))
		setFirstStepReady(false);
	}
	
	const steps = [
		{
			target: '.setupTrainingFirstStep',
			title: "First Training Setup",
			content: 'Create your first training setup.',
			disableBeacon: true,
			placement: "left",
		},
		{
			target: '.setupTrainingSecondStep',
			title: "Fill-in Training Type",
			content: 'Select the training type.',
			disableBeacon: true,
			placement: "bottom",
			modalTriggers: 'setupTraining'
		},
		{
			target: '.setupTrainingThirdStep',
			title: "Enter Training Name",
			content: 'Enter the training name.',
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.setupTrainingFourthStep',
			title: "Training Date and Time",
			content: "Select the training date and time.",
			disableBeacon: true,
			placement: "bottom"
		},
		{
			target: '.setupTrainingFifthStep',
			title: "Choose Training Fee",
			content: "Select if you want the training for free or with pay.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.setupTrainingSixthStep',
			title: "Enter Training Location",
			content: "Put the location of the training.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.setupTrainingSeventhStep',
			title: "Setup Trainig Settings",
			content: "Setup what you want the training to be access.",
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.setupTrainingEightStep',
			title: "Cancel Training Setup",
			content: 'To cancel you training setup.',
			disableBeacon: true,
			placement: "top"
		},
		{
			target: '.setupTrainingNinthStep',
			title: "Save Trainig Setup",
			content: 'Save your training setup.',
			disableBeacon: true,
			placement: "top"
		},
	]

	useEffect(() => {
		const interval = setInterval(() => {
			const el = document.querySelector('.setupTrainingFirstStep');
			if (el) {
				clearInterval(interval);
				setFirstStepReady(true);
			}
		}, 100);
		return () => clearInterval(interval);
	}, []);

	return (
		firstStepReady && 
		<JoyrideWrapper 
			run={Boolean(walkthrough.data.setupTraining)} 
			steps={steps} 
			setter={endTour} 
			end={end}
			p_name="setupTraining" 
			featureName="setup"
		/>
	);
}
